
export function pushBookingCompleteEvent({ results, bookingType, value }) {
  if (!results || !bookingType || value === undefined) {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'booking_complete',
    transaction_id: results.bookingId,
    value,
    currency: 'USD',
    bookingType,
    bedrooms: results.address.bedrooms,
    bathrooms: results.address.bathrooms,
    zip: results.address.zipCode,
  })
}

export function pushUserSignupEvent({ user, formResults }) {
  if (!user || !user.id || !formResults) {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'user_signup',
    user_id: user.id,
    leadSource: formResults.leadSource,
    zip: formResults.zipCode,
    bedrooms: formResults.bedrooms,
    bathrooms: formResults.bathrooms,
  })
}
